import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AccountModal } from "../../rows/account-modal";
import UserIcon from "../../atoms/icons/user-icon";
import { UserData } from "../user-data";
import { WithMember } from "@quintype/components";
import { IS_OPEN_LOGIN_FORM, USER_SUBSCRIPTION } from "../../helper/actions";

import "./user-profile-icon.m.css";

class UserBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginFormOpen: this.props.isLoginOpen || false
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isLoginOpen } = this.props;
    if (isLoginOpen !== prevProps.isLoginOpen && isLoginOpen) {
      this.props.manageLoginForm(true);
      this.setState({ loginFormOpen: true });
    }
    if (isLoginOpen !== prevProps.isLoginOpen && !isLoginOpen) {
      this.props.manageLoginForm(false);
      this.setState({ loginFormOpen: false });
    }
    if (this.props.member !== prevProps.member && !this.props.member) {
      this.props.userSubscriptionDetails({ userHasSubscription: false, userSubscription: [] });
    }
  }

  toggleModal() {
    this.setState(prevState => {
      this.props.manageLoginForm(!prevState.loginFormOpen);
      return {
        loginFormOpen: !prevState.loginFormOpen
      };
    });
  }

  render() {
    return (
      <WithMember>
        {({ member, logout, checkForMemberUpdated, isLoading }) => {
          return (
            !isLoading && (
              <React.Fragment>
                {!member ? (
                  <div>
                    <button
                      className="pressable"
                      aria-label="Login"
                      onClick={this.toggleModal}
                      styleName="user-profile-icon"
                    >
                      <UserIcon />
                    </button>
                    {this.state.loginFormOpen && (
                      <AccountModal onBackdropClick={this.toggleModal} checkForMemberUpdated={checkForMemberUpdated} />
                    )}
                  </div>
                ) : (
                  <div>
                    <UserData
                      member={member}
                      logout={logout}
                      onBackdropClick={() => this.setState({ loginFormOpen: false })}
                    />
                  </div>
                )}
              </React.Fragment>
            )
          );
        }}
      </WithMember>
    );
  }
}
UserBase.propTypes = {
  isLoginOpen: PropTypes.bool,
  manageLoginForm: PropTypes.func,
  userSubscriptionDetails: PropTypes.func,
  member: PropTypes.object
};

const mapDispatchToProps = dispatch => ({
  manageLoginForm: function(payload) {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: payload
    });
  },
  userSubscriptionDetails: function(payload) {
    dispatch({
      type: USER_SUBSCRIPTION,
      payload: payload
    });
  }
});

const mapStateToProps = state => ({
  isLoginOpen: get(state, ["isLoginOpen"], false),
  member: get(state, ["member"], null)
});

export const User = connect(mapStateToProps, mapDispatchToProps)(UserBase);
